import ReactECharts from "echarts-for-react";

import { CurveType, InvestmentRatingMap } from "../../constants/maps";
import { GraphDataDTO } from "../../types/dto";

const getChartData = (row: GraphDataDTO) => ({
  xAxis: [
    {
      type: "value",
      show: false,
      gridIndex: 0,
      width: 50,
    },
  ],
  yAxis: [
    {
      type: "value",
      show: false,
      gridIndex: 0,
      height: 60,
    },
  ],
  series: [
    {
      name: "Display",
      type: "line",
      xAxisIndex: 0,
      yAxisIndex: 0,
      data: row.curveTypes[CurveType.REVENUE].curveCoordinates,
      showSymbol: false,
      animation: false,
      lineStyle: {
        color: "#c9c7c7",
      },
      markLine: {
        symbol: "none",
        label: {
          show: false,
        },
        data: [
          {
            xAxis: row.curveValue,
            lineStyle: {
              color: InvestmentRatingMap[row.rating].curveColor,
              typeof: "dashed",
              width: 2,
            },
          },
        ],
      },
    },
  ],
});

type MiniCurveProps = {
  row: GraphDataDTO;
};

const MiniCurve = ({ row }: MiniCurveProps) => (
  <ReactECharts
    option={getChartData(row)}
    style={{ height: "170px", width: "70px" }}
    opts={{ renderer: "svg" }}
  />
);

export default MiniCurve;
